/*
 * @Author: your name
 * @Date: 2022-01-09 17:46:12
 * @LastEditTime: 2022-03-02 23:33:50
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\utils\error-handler.js
 */

import alertService from './alert-service'
const code_400 = "请求参数异常"
const code_401 = "身份认证失败"
const code_403 = "无访问权限"
const code_404 = "找不到请求页面(404)"
const code_408 = "请求超时(408)"
const code_500 = "服务器内部错误(500)"
const code_501 = "服务未实现(501)"
const code_502 = "网络错误，错误网关(502)"
const code_503 = "服务不可用(503)"
const code_504 = "网络超时(504"
const code_505 = "HTTP版本不受支持(505)"
const defaultCode = "服务端异常，请联系技术支持"

const ExceptionHandler = function(error) {
    let errorMessage = "";
    if(error.msg) {
        errorMessage = error.msg
    }
    else{
        switch (error.code) {
            case 400: errorMessage = code_400; break;
            case 401: errorMessage = code_401; break;
            case 403: errorMessage = code_403; break;
            case 404: errorMessage = code_404; break;
            case 408: errorMessage = code_408; break;
            case 500: errorMessage = code_500; break;
            case 501: errorMessage = code_501; break;
            case 502: errorMessage = code_502; break;
            case 503: errorMessage = code_503; break;
            case 504: errorMessage = code_504; break;
            case 505: errorMessage = code_505; break;
            default:
            errorMessage = defaultCode;
        }
    }
    alertService.notify(errorMessage, 'danger')
}

export default {
    ExceptionHandler
}